import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, TimeRange } from '@library/store/measures/measures.interface';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss']
})
export class YearPickerComponent implements OnInit {

  date = new FormControl();

  @Input() value: TimeRange;
  @Output() valueChange = new EventEmitter<TimeRange>();

  @Input() touchUi = false;

  @Input() minDate = moment('2011');
  @Input() maxDate = null;

  constructor() { }

  ngOnInit(): void {
    this.date.valueChanges.subscribe((date: moment.Moment) => {
      this.valueChange.next({
        dateBegin: startOfApiScale(date.clone(), EnumApiScales.ONE_WEEK),
        dateEnd: endOfApiScale(date.clone(), EnumApiScales.ONE_WEEK),
      });
    })
    this.date.patchValue(this.value.dateBegin, {emitEvent: false})
  }

  ngOnChanges() {

    this.date.setValue(moment(this.value.dateBegin).clone().add(1, "w"), {emitEvent: false});

  }

  setYear(normalizedMonthAndYear: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue = this.date.value!;
    ctrlValue.year(normalizedMonthAndYear.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

}
